import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App.js';
import { consumeAuthActivationRoute } from './auth/auth-activation.js';
import { ErrorBoundary } from './app/ErrorBoundary.js';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const initialAuthRoute = consumeAuthActivationRoute(window.location, window.history);

ReactDOM.createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App initialAuthRoute={initialAuthRoute} />
    </ErrorBoundary>
  </StrictMode>
);
